// Public rhythm. Numeric spacing values use the existing 8px MUI scale.
export const publicSpacing = {
  navHeight: { xs: 68, md: 80 },
  heroTop: { xs: 4, sm: 4, md: 5 },
  heroBottom: { xs: 4, sm: 5, md: 6 },
  section: { xs: 4, sm: 5, md: 6 },
  compact: { xs: 3, sm: 3.5, md: 4 },
  headingBody: 2,
  bodyAction: 3,
  bodyContent: { xs: 2, md: 3 },
  cardGap: { xs: 2, md: 3 },
  gridGap: { xs: 3, md: 5 },
  gutter: { xs: 2.5, sm: 4, md: 5 },
  contentWidth: 1280,
  readingWidth: 790,
};
export const publicPageContainerSx = {
  width: '100%', maxWidth: publicSpacing.contentWidth, mx: 'auto',
  px: publicSpacing.gutter, boxSizing: 'border-box', minWidth: 0,
};
export const publicHeroSx = { pt: publicSpacing.heroTop, pb: publicSpacing.heroBottom };
export const publicSectionSx = { py: publicSpacing.section, scrollMarginTop: 104 };
export const publicCardSx = { p: { xs: 3, md: 4 }, borderRadius: 3, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' };
export const publicPageHeaderSx = { maxWidth: 900, mx: 0, textAlign: 'left', mb: publicSpacing.compact };
export const publicPageSubtextSx = { maxWidth: publicSpacing.readingWidth, mx: 0, color: 'text.secondary', lineHeight: 1.7 };
